import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {ForYouSubSection} from './shared/ForYouSubSection'
import {ChangesRequested} from './reviews/ChangesRequested'
import {RequiredReviewer} from './mergeability/RequiredReviewer'
import {PendingChecks} from './mergeability/PendingChecks'
import {ApprovableChecks} from './mergeability/ApprovableChecks'
import {AwaitingApprovalChecks} from './mergeability/AwaitingApprovalChecks'
import {MergeConflicts} from './mergeability/MergeConflicts'
import {FailingChecks} from './mergeability/FailingChecks'
import {CompletedChecks} from './mergeability/CompletedChecks'
import {Findings} from './findings/Findings'
import {UnresolvedComments} from './commenting/UnresolvedComments'
import {Deployments} from './deployments/Deployments'
import {ResolvedComments} from './commenting/ResolvedComments'
import {ReviewRequested} from './reviewer/ReviewRequested'
import {ReviewPending} from './reviewer/ReviewPending'
import {ChangesSinceLastReview} from './reviewer/ChangesSinceLastReview'
import {Approved} from './reviews/Approved'
import {CommentReview} from './reviews/CommentReview'
import {ForYouSectionError, ForYouSectionSkeleton} from './ForYouSectionFallbacks'
import {ForYouItemBoundary} from './shared/ForYouItemBoundary'
import {SyncCommentData} from './commenting/shared/SyncCommentData'

export function ForYouSection() {
  return (
    <ErrorBoundary boundaryName="ForYouSection" fallback={<ForYouSectionError />}>
      <Suspense fallback={<ForYouSectionSkeleton />}>
        <ForYouSectionContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function ForYouSectionContent() {
  return (
    <div className="d-flex gap-3 flex-column">
      <SyncCommentData />

      <NeedsAttentionSection />
      <RelevantToYouSection />
      <CompletedSection />
    </div>
  )
}

function NeedsAttentionSection() {
  return (
    <ForYouSubSection title="Needs attention">
      <ForYouItemBoundary name="MergeConflicts">
        <MergeConflicts />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ChangesRequested">
        <ChangesRequested />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="FailingChecks">
        <FailingChecks />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ApprovableChecks">
        <ApprovableChecks />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="Findings">
        <Findings />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="UnresolvedComments">
        <UnresolvedComments />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ReviewRequested">
        <ReviewRequested />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ReviewPending">
        <ReviewPending />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ChangesSinceLastReview">
        <ChangesSinceLastReview />
      </ForYouItemBoundary>
    </ForYouSubSection>
  )
}

function RelevantToYouSection() {
  return (
    <ForYouSubSection title="Relevant">
      <ForYouItemBoundary name="Approved">
        <Approved />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="CommentReview">
        <CommentReview />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="PendingOrAwaitingApprovalChecks">
        <PendingChecks />
        <AwaitingApprovalChecks />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="Deployments">
        <Deployments />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="RequiredReviewer">
        <RequiredReviewer />
      </ForYouItemBoundary>
    </ForYouSubSection>
  )
}

function CompletedSection() {
  return (
    <ForYouSubSection title="Completed">
      <ForYouItemBoundary name="CompletedChecks">
        <CompletedChecks />
      </ForYouItemBoundary>

      <ForYouItemBoundary name="ResolvedComments">
        <ResolvedComments />
      </ForYouItemBoundary>
    </ForYouSubSection>
  )
}
